import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
	configAdornmentSelect: {
		"& button ": {
			padding: "1px",
		},
	},
}));
